import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { ScrollFade } from "@cian/adfox-templates/es/components/ScrollFade";
import * as React from 'react';
import { Base64 } from 'js-base64';

import styles from './AsideBanner.css';

export function AsideBanner({ bundleParams }: TAdFoxBannerTemplate) {
  if (!bundleParams?.htmlBase64) {
    return null;
  }

  const decodedParams = Base64.decode(bundleParams.htmlBase64);
  const parsedDecodedParams = JSON.parse(decodedParams);

  const { url, title, description, phone, footnote, buttonText, image } =
    parsedDecodedParams;
  const isVisibleFooter =
    Boolean(description) || Boolean(buttonText) || Boolean(footnote);

  return (
    <a
      href={url}
      target='_blank'
      rel='nofollow noopener'
      className={styles['container']}
    >
      <div className={styles['content']}>
        <div className={styles['image']}>
          <img src={image} alt={title} />
          <div className={styles['label']}>Реклама</div>
        </div>
        <div className={styles['aside']}>
          <h4 className={styles['title']}>{title}</h4>
          {phone && <span className={styles['phone']}>{phone}</span>}
        </div>
      </div>
      {isVisibleFooter && (
        <div className={styles['footer']}>
          <p className={styles['description']}>{description}</p>
          {footnote && (
            <div className={styles['note']}>
              {footnote}
              <ScrollFade size={14} />
            </div>
          )}
        </div>
      )}
    </a>
  );
}
